import script from "./EventList.vue?vue&type=script&setup=true&lang=js"
export * from "./EventList.vue?vue&type=script&setup=true&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ad204a7c&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad204a7c"]])

export default __exports__